export const CALENDAR_DAY_VIEW = 'CalendarDayView';
export const MAIL_LIST_VIEW = 'MailListView';
export const MAIL_READING_PANE_VIEW = 'MailReadingPaneView';
